















































































































import QPaginate from "@/common/qPaginate.vue";
import QSearch from "@/common/qSearch.vue";
import QTableHeader from "@/common/qTableHeader.vue";
import ProductEdit from "@/components/admin/productEdit.vue";
import { Component, Vue } from "vue-property-decorator";
import ProductApi from "@/api/productApi";
import PaginateModel from "@/model/paginate";
import Product from "@/model/product";
import productApi from "@/api/productApi";
import qNotify from "../../common/qNotify";
import { HTTP_STATUS_OK } from "../../common/constant";

@Component({
  name: "ProductsList",
  components: {
    QSearch,
    QPaginate,
    QTableHeader,
    ProductEdit,
  },
})
export default class ProductsList extends Vue {
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public products: Product[] = [];
  public searchParams = {
    item_code: "",
    item_name: "",
  };
  public loading = false;
  public errors = {};

  // コード	来歴	画像	カテゴリ	品名	製品説明
  public headers = [
    { id: "order", name: "表示順", order: "" },
    { id: "item_code", name: "コード", order: "desc" },
    { id: "prvnc", name: "来歴", order: "" },
    { id: "item_image", name: "画像" },
    { id: "category_name", name: "カテゴリ", order: "" },
    { id: "item_name_1", name: "品名", order: "" },
    { id: "item_discription", name: "製品説明" },
    { id: "", name: "" },
  ];

  mounted() {
    this.errors = {};
    this.parserQuery();
    this.filter();
  }

  public parserQuery() {
    let { query } = this.$router.currentRoute;
    this.searchParams = { ...this.searchParams, ...query };
  }

  public filter(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    query = { ...query, ...this.searchParams, ...addition };
    if (clear) {
      query = {};
    }
    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public doSearch(query: any): void {
    this.getList(query);
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
  }

  public async getList(query: any) {
    const result = await ProductApi.getAll(query);
    this.loading = true;
    this.pagination = result.paginate;
    this.products = result.list;
  }

  public edit(product: Product) {
    (this.$refs.productEdit as ProductEdit).show(product);
  }

  public resetSearch() {
    this.searchParams = {
      item_code: "",
      item_name: "",
    };
    this.filter(true);
  }

  public productStatus(product: Product) {
    return product.status == 0 ? "off" : "";
  }

  public async changeOrder(index, product: Product) {
    if (!product.order) {
      product.order = null;
    }
    const result = await productApi.edit(product.item_code, product);

    if (result.meta.status != HTTP_STATUS_OK) {
      const error = result?.meta?.errors?.order[0] || result?.meta?.message;
      let erorrList = {};
      erorrList[`validate.${index}.order`] = [error];
      this.errors = erorrList;
      qNotify.error({
        text: error,
      });
    } else {
      this.filter();
      this.errors = [];
    }
  }

  public getProductsModified() {
    const data = [];
    this.products.every((product: Product) => {
      if (product.is_changed) {
        data.push({
          item_code: product.item_code,
          order: product.order,
        });
      }
      return true;
    });
    return data;
  }

  public async updateOrder() {
    const result = await productApi.updateOrder({ items: this.getProductsModified() });

    if (result.meta.status != HTTP_STATUS_OK) {
      // let erorrList = {};
      // erorrList[`validate.${index}.order`] = [error];
      this.errors = result.meta.errors;
      qNotify.error({
        text: result.meta.message,
      });
    } else {
      this.filter();
      this.errors = [];
    }
  }
}
